/**
 * Script to open the first accordion item on product page load.
 * Using .click() instead of .setAttribute('open', '') ensures 
 * the theme's internal state remains in sync. JL
 */

document.addEventListener('DOMContentLoaded', () => {
  // Find the first accordion-disclosure element within the product info block items
  const firstAccordion = document.querySelector('.product-info__block-item accordion-disclosure.accordion');
  
  if (firstAccordion) {
    const details = firstAccordion.querySelector('details');
    const summary = firstAccordion.querySelector('summary');

    // Only click if it's not already open
    if (details && summary && !details.hasAttribute('open')) {
      // Small delay ensures any theme-specific initialization scripts have finished
      setTimeout(() => {
        summary.click();
      }, 100);
    }
  }
});